// VCARD Design Tokens — vcard variant
import type { ThemeDefinition } from '@vcard/shared/types';

// Hardcoded Tailwind color values (browser-safe, no require())
// stone: 50=#fafaf9 100=#f5f5f4 200=#e7e5e4 300=#d6d3d1 400=#a8a29e 500=#78716c
// zinc:  200=#e4e4e7 400=#a1a1aa 600=#52525b 700=#3f3f46 800=#27272a 900=#18181b
// violet: 600=#7c3aed 800=#5b21b6   fuchsia: 500=#d946ef 800=#86198f

const vcardTheme: ThemeDefinition = {
  colors: {
    main:         { light: '#fafaf9', dark: '#18181b' },
    card:         { light: '#e7e5e4', dark: '#27272a' },
    surface:      { light: '#d6d3d1', dark: '#3f3f46' },
    action:       { light: '#5b21b6', dark: '#86198f' },
    actionHover:  { light: '#7c3aed', dark: '#d946ef' },
    confirm:      { light: '#a8a29e', dark: '#a1a1aa' },
    confirmHover: { light: '#78716c', dark: '#e4e4e7' },
    textPrimary:  { light: '#27272a', dark: '#f5f5f4' },
    textSecondary:{ light: '#3f3f46', dark: '#d6d3d1' },
    textMuted:    { light: '#52525b', dark: '#d6d3d1' },
    border:       { light: '#a8a29e', dark: '#3f3f46' },
    inputBg:      { light: '#ffffff', dark: '#3f3f46' },
  },
  borderRadius: {
    card: '40px',
    container: '25px',
    page: '1.5rem',
    button: '9999px',
    input: '0.75rem',
    badge: '6px',
    full: '9999px',
  },
  borderWidth: {
    default: '1px',
    thick: '2px',
    avatar: '6px',
    device: '8px',
  },
  textures: {
    main: {
      light: '/textures/sandTexture.jpg',
      dark: '/textures/sandTexture.jpg',
      size: '1080px 1080px',
      blendLight: 'multiply',
      blendDark: 'overlay',
      opacityLight: 0.07,
      opacityDark: 0.20,
    },
    surface: { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
    card:    { light: '', dark: '', size: '', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0, opacityDark: 0 },
  },
};

export default vcardTheme;
